<div id="memoryContainer" class=container1>
    <div id="memoryTitle" class="main-content paddingSection">
        <div id="ftags" class="fact_tags mt-3 clr-white">{{memoryTitle}}</div>
    </div>
</div>